import Artist from './artist';

export default class Artwork {
  public id!: string;
  public title!: string;
  public imageURL!: string;
  public authorId!: string;
  public authorName!: any;
  public author!: Artist;
  public date!: number;
  public type!: string;
  public description!: string;
}